import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tabs } from "antd";
import Datefilter from '../../../common/commonDateFIlter'
import Requested from './requested';
import Planning from './planning';
import Confirmed from './confirmed';
import Cancelled from './cancelled';
import * as WeddingAction from '../../../actions/weddingAction'
import moment from 'moment';
import { Spinner } from 'react-bootstrap';
const { TabPane } = Tabs;

const Index = () => {
  const [ status, setStatus ] = useState("requested");
  const dispatch = useDispatch();

  const totalRequestedResults = useSelector(state => state.wedding.weddingRequested?.total_results);
  const totalPlanningResults = useSelector(state => state.wedding.weddingPlanning?.total_results);
  const totalConfirmedResults = useSelector(state => state.wedding.weddingConfirmed?.total_results);
  const totalCancelledResults = useSelector(state => state.wedding.weddingCancelled?.total_results);
  const isDataLoading = useSelector(
    (state) => state.holidayListing.isDataLoading
  );
  const START_DATE = useSelector(state => state.wedding.startDate);
  const END_DATE = useSelector(state => state.wedding.endDate);
  const SEARCH_TERM = useSelector(state => state.wedding.searchTerm);
  const PAGE_NO = useSelector(state => state.wedding.pageNo);
  
  useEffect(() => {
    dispatch(WeddingAction.getWeddingRequested(1));
    dispatch(WeddingAction.getWeddingPlanning(1));
    dispatch(WeddingAction.getWeddingConfirmed(1));
    dispatch(WeddingAction.getWeddingCancelled(1));
  }, []);

  useEffect(() => {
    // if(status === "requested") {
    //   dispatch(familyFirstSearchRequested("", 'requested'));
    // }
    // else if(status === "planning") {
    //   dispatch(familyFirstSearchRequested("", 'planning'));
    // }
    // else if(status === "confirmed") {
    //   dispatch(familyFirstSearchRequested("", 'confirmed'));
    // }
    // else if(status === "cancelled") {
    //   dispatch(familyFirstSearchRequested("", 'cancelled'));
    // }
  }, [status]);

  const handleTabChange = (key) => {
    dispatch(WeddingAction.setSearchTerm(''))
    
    if(key === '2') {
      dispatch(WeddingAction.setPageNo(1))
      setStatus('planning')
      dispatch(WeddingAction.searchWeddingRequests('', START_DATE, END_DATE, "planning", 1));
    }
    else if(key === '3') {
      dispatch(WeddingAction.setPageNo(1))
      setStatus('confirmed')
      dispatch(WeddingAction.searchWeddingRequests('', START_DATE, END_DATE, "confirmed", 1));
    }
    else if(key === '4') {
      dispatch(WeddingAction.setPageNo(1))
      setStatus('cancelled')
      dispatch(WeddingAction.searchWeddingRequests('', START_DATE, END_DATE, "cancelled", 1));
    }
    else {
      dispatch(WeddingAction.setPageNo(1))
      setStatus('requested')
      dispatch(WeddingAction.searchWeddingRequests('', START_DATE, END_DATE, "requested", 1));
    }
  };
  
  const overallWeddingRequest = 
  totalRequestedResults+ 
  totalPlanningResults+ 
  totalConfirmedResults +
  totalCancelledResults; 

  

  const handleStartDateChange = (date) => {
    dispatch(WeddingAction.setStartDate(moment(date).format("YYYY-MM-DD")));
    dispatch(WeddingAction.searchWeddingRequests(SEARCH_TERM, moment(date).format("YYYY-MM-DD"), null, status, PAGE_NO));
  };

  const handleEndDateChange = (date) => {
    dispatch(WeddingAction.setEndDate(moment(date).format("YYYY-MM-DD")));
    dispatch(WeddingAction.searchWeddingRequests(SEARCH_TERM, START_DATE, moment(date).format("YYYY-MM-DD"), status, PAGE_NO));
  };

  const handleStartClear = (e) => {
    e.stopPropagation();
    dispatch(WeddingAction.setStartDate(null));
  };

  const handleEndClear = (e) => {
    e.stopPropagation();
    dispatch(WeddingAction.setEndDate(null));
    dispatch(WeddingAction.getWeddingRequested(1));
    dispatch(WeddingAction.getWeddingPlanning(1));
    dispatch(WeddingAction.getWeddingConfirmed(1));
    dispatch(WeddingAction.getWeddingCancelled(1));
  };

  return (
    <>
    <div style={{ position: "absolute", right: 50 }}>
      <Datefilter 
        status={status}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        ffStartDate={START_DATE}
        ffEndDate={END_DATE}
        handleStartClear={handleStartClear}
        handleEndClear={handleEndClear}
      />
    </div>
    <div className="enquiry-tabs-holder">
      <p className="title-holder">{overallWeddingRequest} Wedding Requests</p>
      <Tabs defaultActiveKey="1" onChange={handleTabChange}>
        <TabPane tab={`${totalRequestedResults} Requested`} key="1">
          <Requested status={status}/> 
        </TabPane>
        <TabPane tab={`${totalPlanningResults} Planning`} key="2">
          <Planning status={status}/> 
        </TabPane>
        <TabPane tab={`${totalConfirmedResults} Confirmed`} key="3">
          <Confirmed  status={status}/> 
        </TabPane>
        <TabPane tab={`${totalCancelledResults} Cancelled`} key="4">
          <Cancelled status={status}/> 
        </TabPane>
      </Tabs>
      {isDataLoading &&
            <p className="loding-spinner">
              <Spinner animation="border" variant="primary" />
            </p>
          }
      <div>
    </div>
    </div>
  </> 
  )
};

export default Index;